import Vue from 'vue'

export function initMixin (howlerService) {
    Vue.mixin({
        methods: {
            addSounds: function (soundsArray) {
                return howlerService.addSounds(soundsArray)
            },
            playAllSounds: async function () {
                return await howlerService.playAllSounds()
            },
            setTotalVolume: function (totalVolume) {
                howlerService.setTotalVolume(totalVolume)
            }
        }
    })
}
